<div class="ds-dashbaord-vertical__menu vertical-menu">

  @if(isSelfSetupOn){
  <div class="self-setup__container active" id="self-setup_container-guide">
    @if(isBasicFunctionPurchased){
    <div class="self-setup__content" (click)="fnGoToSelfSetup()">
      <a id="self-setup-link" href="javascript:void(0);">{{ 'Setup Guide' | translate }} 
        <img id="self-setup-icon" [src]="ICONS.CHEVRON_RIGHT" alt="">
      </a>
      <p><span class="self-setup-progress">{{selfSetupPercentage ?? 0}}%</span></p>
    </div>
    <ds-progress-bar [progressBarInput]="selfSetupProgressBar">
    </ds-progress-bar>
   }
   @if(!isBasicFunctionPurchased){
     <div class="unlock-features" [ngClass]="{'align-items-center': isSidebarCollapsed()}" (click)="fnShowBookDemoPanel()">
      <div class="unlock-features__info" >
        <img [src]="ICONS.LOCK_OFF" alt="">
        @if(!isSidebarCollapsed()){ <p>{{ 'text_unlock_full_features' | translate }}</p>}
      </div>
      @if(!isSidebarCollapsed()){<ds-button [buttonInput]="subscribeButtonConfig" (click)="fnShowBookDemoPanel()"></ds-button>}
    </div>
   }  
  </div>
}
  <div data-simplebar [ngClass]="{
  'is__trail-and-setup': basicFunctionRemainingTrialDays > 0 && isSelfSetupOn,
  'is__only-trail-or-setup': (basicFunctionRemainingTrialDays > 0 || isSelfSetupOn) 
                                 && !(basicFunctionRemainingTrialDays > 0 && isSelfSetupOn),
  'is__not-trail-or-setup': !(basicFunctionRemainingTrialDays > 0 || isSelfSetupOn),
  'disabled': isBasicFunctionPurchased && isSelfSetupOn && selfSetupPercentage != 100
 }">
    <ngx-simplebar style="max-height: 100vh">
      <div id="sidebar-menu">
        <ul class="metismenu list-unstyled" id="side-menu">
          @for (item of menuItems; track item.id; let i = $index) {
            @if(item.isTitle){<li class="menu-title">{{ item.label | translate }}</li>}
            @if(!item.isTitle && !item.isLayout){<li [ngbTooltip]="item.label" container="body" tooltipClass="left-menu-tooltip-class ml-1" [closeDelay]=".01" [openDelay]="200">
              @if(hasItems(item)){<a data-href="javascript:void(0);" class="is-parent"
                [attr.id]="'menu-parent-' + item.id"
                [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge, 'activeMenu': selectedMenuId == item.id}">
                @if(item.icon){<i class="bx {{selectedMenuId == item.id ? item.iconInactive :item.icon}}"></i>}
                <span> {{ item.label | translate }}</span>
                @if(item.badge){<span class="badge rounded-pill float-end bg-{{item.badge.variant}}">{{item.badge.text | translate}}</span>}
              </a>}
              @if(!hasItems(item)){<a data-href="javascript:void(0);" class="side-nav-link-ref"
                [attr.id]="'menu-item-' + item.id"
                [ngClass]="{'mm-active': selectedMenuId == item.id, 'activeMenu': selectedMenuId == item.id }"
                (click)="navigateToSettings(item)">
                <img [src]="'assets/svg-icons/dashboard/' + item.iconInactive + '.svg'" alt="">
                <span> {{ item.label | translate }} 
                </span>

                @if(item.badge){<span class="badge rounded-pill bg-{{item.badge.variant}} float-end ml-2"
                  >{{item.badge.text | translate}}</span>}
              </a>}
              @if(hasItems(item)){<ul class="sub-menu" aria-expanded="false">
                @for (subitem of item.subItems; track subitem.id; let j = $index) {<li>
                  @if(!hasItems(subitem)){<a [routerLink]="subitem.link" class="side-nav-link-ref"
                    [attr.id]="'subitem-' + subitem.id"
                    [attr.data-parent]="subitem.parentId">
                    <span>{{ subitem.label | translate}}</span>
                    @if(subitem.badge){<span class="badge rounded-pill bg-{{subitem.badge.variant}} float-end"
                      >{{subitem.badge.text | translate}}</span>}
                  </a>}
                  @if(hasItems(subitem)){<a class="side-nav-link-a-ref has-arrow" data-href="javascript:void(0);"
                    [attr.id]="'sub-parent-' + subitem.id"
                    [attr.data-parent]="subitem.parentId">
                    <span>{{ subitem.label | translate}}</span>
                    @if(subitem.badge){<span class="badge rounded-pill bg-{{subitem.badge.variant}} float-end"
                      >{{subitem.badge.text | translate}}</span>}
                  </a>}
                  @if(hasItems(subitem)){<ul class="sub-menu mm-collapse" aria-expanded="false">
                    @for (subSubitem of subitem.subItems; track subSubitem.id; let k = $index) {
                      <li>
                        <a [attr.id]="'subsub-' + subSubitem.id" [attr.data-parent]="subSubitem.parentId" [routerLink]="subSubitem.link"
                          class="side-nav-link-ref">
                          <span>{{ subSubitem.label | translate }}</span>
                        </a>
                      </li>
                    }
                  </ul>}
                </li>}
              </ul>}
            </li>}
          }
        </ul>
      </div>
    </ngx-simplebar>
  </div>

    @if(isFinanceManager && basicFunctionRemainingTrialDays > 0 && bandId > 0){<div class="free-trail__container" id="free-trail_container" (click)="openEssPackPanel()">
    <div class="free-trail__content">
      <p><img [src]="ICONS.CLOCK" alt=""><span class="free-trial-text">{{ 'free_trial' | translate }}</span></p>
      <a id="free-trial-link" href="javascript:void(0);">{{ basicFunctionRemainingTrialDays }} {{ 'days_left' | translate }} 
        <img id="free-trial-icon" [src]="ICONS.CHEVRON_RIGHT" alt="" (click)="openEssPackPanel()">
      </a>
    </div>
    <ds-progress-bar [progressBarInput]="freeTrialProgressBar">
    </ds-progress-bar>
  </div>}


</div> 

<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button id="close-btn" type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="closeVideo()">
          <span aria-hidden="true" class="video-close">×</span>
        </button>
      </div>
      <div class="modal-body">
        <iframe _ngcontent-ng-c4277079693="" width="100%" height="360" frameborder="0" webkitallowfullscreen=""
          mozallowfullscreen="" allowfullscreen="" src="https://www.youtube.com/embed/videoseries?si=PJ5vaZsFxgvZojSH&amp;list=PLugzlMICZR8hxz1HfZvEIvVh8QOtbK85k"
          class="video-height-youtube">
        </iframe>
      </div>
    </div>
  </div>
</div>
<!-- will use new Panel common component  -->
@if(isDisplayEssDetail){<div class="overLayDiv active"></div>}
@if(isDisplayEssDetail){<div id="rightSideBar">
  <div class="rightSidePanel d-flex flex-column">
    <header class="panel-header">
      <div class="viewDemo title-and-video">
        <h2>{{ "info" | translate : param }}</h2>
      </div>
    </header>
    <div class="eod-panel-body-with-footer">
      <div class="block mt-2">

        <h6 class="info-text">
          <span class="mr-2">1.</span>
          <span>
            {{ "ess_pack_text6" | translate : param }}
            <span> 1<sup>st</sup> </span>
            {{ "ess_pack_text50" | translate : param }}
          </span>
        </h6>
        <h6 class="info-text">
          <span class="mr-2">2.</span>
          <span>
            {{ "ess_pack_text7" | translate : param }}
            <a class="eod-link-primary" (click)="fnEssBtnClick(1)">{{ "here" | translate }}</a>.
          </span>
        </h6>

      </div>
    </div>
    <footer class="mt-auto py-1 d-flex justify-content-center align-items-center gap-2 height-60px">
      <button type="button" class="btn eod-btn-outline-warning" (click)="dismissEssPack()">
        {{ "close" | translate : param }}
      </button>
      @if(!claims?.isBasicFunctionPurchased){<button type="button" class="btn eod-btn-primary" (click)="fnShowBookDemoPanel()">
        {{ "Request a Demo" | translate : param }}
    </button>}
    </footer>
  </div>
</div>}

 @if(showBookDemoPanel){
 <book-demo-panel (closePanelEvent)="fnCloseBookDemoPanel()"></book-demo-panel>
  }
 